import React from 'react';
import Header from '../components/Header/Header';
import Search from '../components/Search/Search';
import Suggestion from '../components/Suggestion/Suggestion';
import Topic from '../components/Topics/Topic';
import UserSuggestion from '../components/UserSuggestion/UserSuggestion';

const Explore = () => {
  return (
    <>
      <Header />
      <div className="app">
        <div className="app__left">
          <Suggestion />
          <Suggestion />
        </div>
        <div>
          <Search />
          <Topic />
        </div>
        <div className="app__right">
          <UserSuggestion />
          <UserSuggestion />
        </div>
      </div>
    </>
  );
};

export default Explore;
